import * as React from "react";
import { observer } from "mobx-react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Alert, Alignment, Button, Classes, FormGroup, H5, Intent, Popover, Switch, Tooltip } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { toast } from "react-toastify";
import { ICstSped, newICstSped } from "../../model";
import { CstSelect, filterCst, renderCst } from "../utils/CstSelect";
import { SpedEfdStore } from "../../stores/sped/SpedEfdStore";

@observer
export default class CstsIPI extends React.Component<{}, {}> {

    obs = observable({
        open_vincula_cst: false as boolean,
        open_edit_vincula_cst: false as boolean,
        rowCst: [] as any,
        selectCst: newICstSped() as ICstSped,
    })

    constructor(props: any) {
        super(props);
    }

    async handleSaveCST(csts) {

        if (this.obs.selectCst.descricao == "") {
            toast.warning('Selecione um CST-IPI!', {});
            return;
        }

        csts?.map(values => {
            delete values["descricao"]
            if (values.cod == this.obs.rowCst.cod) {
                values.vinculado = this.obs.selectCst.cod
            }
            return values
        })

        csts = csts.filter((value: any) => {
            return value["vinculado"];
        });


        let params = {
            id: SpedEfdStore.obs.index_config_cst._id,
            ipi: csts,
        }

        await SpedEfdStore.handleSaveCST(params)
        this.onClose()
    }

    async handleIgnorarIPI(e: boolean) {
        SpedEfdStore.obs.index_config_cst.ignorar_ipi = e

        let params = {
            id: SpedEfdStore.obs.index_config_cst._id,
            ignorar_ipi: SpedEfdStore.obs.index_config_cst.ignorar_ipi,
        }

        await SpedEfdStore.handleSaveCST(params)
        this.onClose()
    }

    onClose() {
        this.obs.open_vincula_cst = false
        this.obs.open_edit_vincula_cst = false
        this.obs.selectCst = newICstSped()
        this.obs.rowCst = []
    }

    async handleVincularCST(row: any) {
        this.obs.rowCst = row
        this.obs.open_vincula_cst = true
    }

    async handleDesvincularCST(row: any, csts: any) {
        csts?.map(values => {
            delete values["descricao"]
            if (values.cod == row.cod) {
                delete values["vinculado"]
            }
            return values
        })

        csts = csts.filter((value: any) => {
            return value["vinculado"];
        });

        let params = {
            id: SpedEfdStore.obs.index_config_cst._id,
            ipi: csts,
        }

        await SpedEfdStore.handleSaveCST(params)
        this.obs.selectCst = newICstSped()
    }

    render() {
        let ipiText = this.obs.selectCst.descricao != "" ? `${this.obs.selectCst.cod} - ${this.obs.selectCst.descricao.substring(0, 50)}`
            : "Selecione um CST - IPI";

        let labelText = <b>{"Ignorar Configuração CST - IPI"}</b>

        let csts_ipi_select: ICstSped[] = [
            { "cod": "00", "descricao": "Entrada com Recuperação de Crédito" },
            { "cod": "01", "descricao": "Entrada Tributável com Alíquota Zero" },
            { "cod": "02", "descricao": "Entrada Isenta" },
            { "cod": "03", "descricao": "Entrada Não-Tributada" },
            { "cod": "04", "descricao": "Entrada Imune" },
            { "cod": "05", "descricao": "Entrada com Suspensão" },
            { "cod": "49", "descricao": "Outras Entradas" }
        ]

        let csts_ipi: ICstSped[] = [
            { "cod": "50", "descricao": "Saída Tributada" },
            { "cod": "51", "descricao": "Saída Tributável com Alíquota Zero" },
            { "cod": "52", "descricao": "Saída Isenta" },
            { "cod": "53", "descricao": "Saída Não-Tributada" },
            { "cod": "54", "descricao": "Saída Imune" },
            { "cod": "55", "descricao": "Saída com Suspensão" },
            { "cod": "99", "descricao": "Outras Saídas" },
        ]

        SpedEfdStore.obs.index_config_cst.ipi?.map(i => {
            csts_ipi = csts_ipi?.map(b => {
                if (i.cod == b.cod) {
                    b.vinculado = i.vinculado
                }
                return b
            })
        })

        const textVinculado = (row) => {
            let text: string = ""

            csts_ipi_select?.map(value => {
                if (row.vinculado == value.cod) {
                    return text = `${value.cod} - ${value.descricao}`
                }
            })
            return text
        }

        const handleEditVincularCST = (row: any) => {
            this.obs.rowCst = row
            csts_ipi_select?.map((value: any) => { if (value.cod == row.vinculado) { return this.obs.selectCst = value } })
            this.obs.open_edit_vincula_cst = true
        }

        const formaterVinculado = (cell, row) => {
            return (
                <>
                    {row.vinculado ?
                        <>
                            <Tooltip content={textVinculado(row)} position="right" openOnTargetFocus={false} usePortal={false}>
                                <MDBBtn color="default" rounded size="sm" onClick={() => handleEditVincularCST(row)}>
                                    <img src="/images/checked.png" width="25px" />
                                </MDBBtn>
                            </Tooltip>
                        </>
                        :
                        <MDBBtn color="default" rounded size="sm" onClick={() => this.handleVincularCST(row)}>
                            <img src="/images/block.png" width="25px" />
                        </MDBBtn>
                    }
                </>
            );
        }

        return (
            <>
                <Alert
                    cancelButtonText="Cancelar"
                    confirmButtonText={"Salvar"}
                    isOpen={this.obs.open_vincula_cst}
                    onClose={() => this.onClose()}
                    onConfirm={() => this.handleSaveCST(csts_ipi)}
                    canOutsideClickCancel={true}
                    className="AlertUser"
                    intent={Intent.PRIMARY}
                >

                    <h2 className="titleSEFAZ">Vincule um CST - IPI</h2>
                    <FormGroup className="empresaSelect">
                        <CstSelect
                            items={csts_ipi_select}
                            itemRenderer={renderCst}
                            itemPredicate={filterCst}
                            onItemSelect={(e: ICstSped) => this.obs.selectCst = e}
                        >
                            <Button
                                text={ipiText}
                                rightIcon="double-caret-vertical"
                                alignText={Alignment.LEFT}
                            />
                        </CstSelect>
                    </FormGroup>
                </Alert>

                <Alert
                    cancelButtonText="Cancelar"
                    confirmButtonText={"Salvar"}
                    isOpen={this.obs.open_edit_vincula_cst}
                    onClose={() => this.onClose()}
                    onConfirm={() => this.handleSaveCST(csts_ipi)}
                    canOutsideClickCancel={true}
                    className="AlertUser"
                    intent={Intent.PRIMARY}
                >
                    <h2 className="titleSEFAZ">Editar CST - PIS</h2>
                    <FormGroup className="empresaSelect">
                        <CstSelect
                            items={csts_ipi_select}
                            itemRenderer={renderCst}
                            itemPredicate={filterCst}
                            onItemSelect={(e: ICstSped) => this.obs.selectCst = e}
                        >
                            <Button
                                text={ipiText}
                                rightIcon="double-caret-vertical"
                                alignText={Alignment.LEFT}
                            />
                        </CstSelect>
                    </FormGroup>
                    <div style={{ marginTop: "50px", marginBottom: "-45px" }}>
                        <MDBBtn
                            color="danger"
                            style={{ background: "#dc3545" }}
                            className="btnDefault"
                            onClick={() => this.handleDesvincularCST(this.obs.rowCst, csts_ipi)}
                        >
                            Desvincular
                        </MDBBtn>
                    </div>
                </Alert>

                <MDBCol>
                    <Switch
                        alignIndicator={Alignment.RIGHT}
                        innerLabelChecked="Sim"
                        innerLabel="Não"
                        labelElement={labelText}
                        checked={SpedEfdStore.obs.index_config_cst.ignorar_ipi}
                        onChange={(e: any) => this.handleIgnorarIPI(e.target.checked)}
                        style={{ marginBottom: "20px", float: "left" }}
                    />
                </MDBCol>
                {!SpedEfdStore.obs.index_config_cst.ignorar_ipi &&
                    <BootstrapTable
                        data={csts_ipi}
                    >
                        <TableHeaderColumn dataField="cod" width="1%" isKey={true} hidden >#</TableHeaderColumn>
                        <TableHeaderColumn dataField="cod" width="20%">CST</TableHeaderColumn>
                        <TableHeaderColumn dataField="descricao" width="80%">Descrição</TableHeaderColumn>
                        <TableHeaderColumn dataFormat={formaterVinculado} width="80%">Vinculado</TableHeaderColumn>
                    </BootstrapTable>
                }
            </>
        )
    }
}